var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "IM_top",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.displayMode == 2) ? _c('img', {
    staticClass: "title_img",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "title_2"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "order_text",
    on: {
      "click": _vm.toWorkOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), _c('img', {
    staticClass: "order_img",
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "height": "18px",
      "alt": "单据"
    },
    on: {
      "click": _vm.toWorkOrder
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order_text",
    on: {
      "click": _vm.callgo
    }
  }, [_vm._v("客服电话")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.callis),
      expression: "callis"
    }],
    staticClass: "order_img",
    attrs: {
      "height": "18px",
      "src": "/pc/static/assets/callbtn.png"
    },
    on: {
      "click": _vm.callgo
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b340ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/im/IMTop.vue
// module id = Eo27
// module chunks = 1